import type { AddCatalogForm } from "./AddProductModal";
import type { Session } from "../types/catalog";

type AdminCatalogActionsProps = {
  isAdmin: boolean;
  isAdminHost: boolean;
  session: Session;
  onAddCatalogOpen: (form: AddCatalogForm) => void;
};

function currentReturnPath() {
  const path = `${window.location.pathname}${window.location.search}`;

  if (!path.startsWith("/") || path.startsWith("//")) {
    return "/catalog";
  }

  return path;
}

function accessMessage() {
  return new URLSearchParams(window.location.search).get("__cf_access_message");
}

function adminRefreshUrl() {
  const refreshUrl = new URL(currentReturnPath(), window.location.origin);
  refreshUrl.searchParams.set("admin_session", String(Date.now()));

  return refreshUrl.toString();
}

function accessLogoutUrl() {
  const logoutUrl = new URL("/cdn-cgi/access/logout", window.location.origin);

  return logoutUrl.toString();
}

export function AdminCatalogActions({
  isAdmin,
  isAdminHost,
  session,
  onAddCatalogOpen,
}: AdminCatalogActionsProps) {
  if (isAdmin) {
    return (
      <div className="admin-fab-group" aria-label="Admin catalogue actions">
        <button className="button admin-fab" type="button" onClick={() => onAddCatalogOpen("product")}>
          Add product
        </button>
        <button className="button button--secondary admin-fab" type="button" onClick={() => onAddCatalogOpen("category")}>
          Add category
        </button>
      </div>
    );
  }

  if (!isAdminHost) {
    return null;
  }

  const refreshUrl = adminRefreshUrl();
  const logoutUrl = accessLogoutUrl();
  const currentAccessMessage = accessMessage();
  const prompt = currentAccessMessage === "unauthorized"
    ? "Cloudflare Access denied this session. Check the Zero Trust policy for this email, then log out and try again."
    : session.email
    ? !session.adminEmailsConfigured
      ? "Admin emails are not configured for this deployment."
      : `Signed in as ${session.email}. Log out, then return with an admin email.`
    : "Admin session not confirmed. Refresh Access, or log out if this browser is using the wrong account.";

  return (
    <div className="admin-auth-panel" aria-live="polite">
      <p>{prompt}</p>
      <div className="admin-auth-panel__actions">
        <a className="button admin-fab" href={refreshUrl}>
          Refresh Access
        </a>
        <a className="button button--secondary admin-fab" href={logoutUrl}>
          Log out
        </a>
      </div>
    </div>
  );
}
